/**
 * Menu section with header and items grid
 */
import { memo } from 'react'
import { MenuItem } from '@/types/menu'
import { MenuItemCard } from './MenuItemCard'

interface MenuSectionProps {
  id: string
  name: string
  description?: string
  items: MenuItem[]
  onItemClick: (item: MenuItem) => void
}

export const MenuSection = memo(function MenuSection({ id, name, description, items, onItemClick }: MenuSectionProps) {
  if (items.length === 0) return null

  return (
    <section id={`section-${id}`} className="scroll-mt-[72px]">
      {/* Section Header */}
      <div className="mb-4 sm:mb-5">
        <h2 className="text-xl sm:text-2xl font-bold mb-1">
          {name}
        </h2>
        {description && (
          <p className="text-sm text-muted-foreground">{description}</p>
        )}
      </div>

      {/* Items Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4">
        {items.map((item) => (
          <MenuItemCard key={item.id} item={item} onItemClick={onItemClick} />
        ))}
      </div>
    </section>
  )
})
